<template>
  <v-dialog v-model="show" persistent :max-width="maxWidth">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <slot></slot>
      </div>
    </template>

    <v-card>
      <v-card-title class="headline">{{ question }}</v-card-title>
      <v-card-text>
        <slot name="message"></slot>
        <v-text-field
          v-model.number="qty"
          type="number"
          label="Qty"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="warning" text @click.native="onCloseDialog">Cancel</v-btn>
        <v-btn color="primary" @click="onConfirm">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "QtyDialog",
  props: {
    value: {
      type: Number,
      default: 1,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 290,
    },
    callback: {
      type: Function,
      default: null,
    },

  },
  data() {
    return {
      show: false,
      qty: this.value,
      question: "Quantity",
    };
  },
  methods: {
    onConfirm() {
      this.show = false;
      this.$emit("onConfirm", this.qty);
      if (this.callback) {
        this.callback(this.qty);
      }
    },
    onCloseDialog() {
      this.show = false;
      this.$emit("onCloseDialog");
    },
  },
  watch: {
    showDialog(value) {
      this.show = value;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/QtyDialog.vue